import * as React from "react"
import { Link } from "@reach/router"

export function HeaderSignedOut(props) {
  return <Link to="/signin">Sign in</Link>
}
